module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-and-fall"
    }
  }, [_c('section', {
    staticClass: "device-details-modal modal modal--spacious",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.back($event)
      }
    }
  }, [_c('v-snackbar', {
    attrs: {
      "color": _vm.errorSnack.color,
      "timeout": _vm.errorSnack.timeout,
      "top": ""
    },
    model: {
      value: (_vm.errorSnack.visible),
      callback: function($$v) {
        _vm.$set(_vm.errorSnack, "visible", $$v)
      },
      expression: "errorSnack.visible"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.errorSnack.message) + "\n\t\t\t"), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.errorSnack.visible = false
      }
    }
  }, [_vm._v("\n\t\t\t\tClose\n\t\t\t")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.cloak",
      value: (_vm.isLoading),
      expression: "isLoading",
      modifiers: {
        "cloak": true
      }
    }],
    staticClass: "modal__container"
  }, [_c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__header device-details-modal__header"
  }, [_c('span', {
    staticClass: "device-details-modal__status"
  }, [_c('b', {
    staticClass: "badge badge--left",
    class: {
      'badge--offline': !_vm.device.Online,
        'badge--online': _vm.device.Online
    }
  })]), _vm._v(" "), (_vm.isDeviceNickBeingEdited) ? [_c('v-flex', [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (_vm.deviceNickMask),
      expression: "deviceNickMask"
    }],
    ref: "deviceNickInput",
    staticClass: "modal__title",
    class: [_vm.isModalSizeLowerThenBreakpoint ? 'title--5' : 'title--2', {
      'title-sized': true,
      'unpadded': true,
      'title-colored': true
    }],
    attrs: {
      "flat": "",
      "solo": "",
      "hide-details": ""
    },
    on: {
      "update:options": function($event) {
        return _vm.test()
      },
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveDeviceNick()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.discardDeviceNick()
      }],
      "blur": function($event) {
        return _vm.discardDeviceNick()
      }
    },
    model: {
      value: (_vm.device.DeviceNick),
      callback: function($$v) {
        _vm.$set(_vm.device, "DeviceNick", $$v)
      },
      expression: "device.DeviceNick"
    }
  })], 1)] : [_c('h2', {
    staticClass: "modal__title breakable",
    class: [_vm.isModalSizeLowerThenBreakpoint ? 'title--5' : 'title--2']
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.device.DisplayName) + "\n\t\t\t\t\t\t\t\t"), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDeviceNickBeingEdited),
      expression: "!isDeviceNickBeingEdited"
    }],
    staticClass: "device-details-modal__device-name__edit-button button button--edit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editDeviceNick()
      }
    }
  }, [_c('svg-icon', {
    staticClass: "icon icon--smaller",
    attrs: {
      "icon": "pencil"
    }
  })], 1)])], _vm._v(" "), _c('button', {
    staticClass: "modal__close-button",
    on: {
      "click": _vm.back
    }
  }, [_c('svg-icon', {
    staticClass: "modal__close-button__icon",
    attrs: {
      "icon": "x"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "modal__section device-details-modal__section"
  }, [_c('p', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.device.DeviceBrand)) + " " + _vm._s(_vm.device.DeviceModel) + " • " + _vm._s(_vm._f("deviceAccessLevel")(_vm.device)))]), _vm._v(" "), (_vm.device.AndroidVersion) ? _c('p', [_vm._v("Android " + _vm._s(_vm.device.AndroidVersion))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal__section device-details-modal__section"
  }, [_c('h3', {
    staticClass: "title--general title--5"
  }, [_vm._v("Available at")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "link--primary",
    attrs: {
      "href": _vm.link
    }
  }, [_vm._v(" " + _vm._s(_vm.link))])])]), _vm._v(" "), _c('v-tabs', {
    staticClass: "botbordered device-details-modal__tabs",
    on: {
      "change": _vm.onShowOnMap
    },
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, [_c('v-tab', {
    staticClass: "modal__section device-details-modal__tab",
    class: {
      'unpadded': true
    },
    attrs: {
      "href": "#apps"
    }
  }, [_vm._v("\n\t\t\t\t\t\tInstalled apps\n\t\t\t\t\t")]), _vm._v(" "), _c('v-tab', {
    staticClass: "device-details-modal__tab",
    class: {
      'unpadded': true
    },
    attrs: {
      "href": "#gps"
    }
  }, [_vm._v("\n\t\t\t\t\t\tShow on map\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, [_c('v-tab-item', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.onResize),
      expression: "onResize"
    }],
    attrs: {
      "value": "apps"
    }
  }, [(!_vm.isLoading) ? _c('v-layout', {
    staticClass: "modal__section device-details-modal__tab--item",
    attrs: {
      "align-space-around": "",
      "justify-center": "",
      "column": "",
      "fill-height": ""
    }
  }, [(_vm.getPackagesError) ? _c('p', [_vm._v("No apps found.")]) : _vm._l((_vm.sortedPackages), function(package) {
    return _c('v-layout', {
      key: package.appName + package.versionName,
      staticClass: "device-details-modal__app",
      attrs: {
        "align-center": !_vm.isModalSizeLowerThenBreakpoint,
        "justify-space-between": "",
        "column": _vm.isModalSizeLowerThenBreakpoint
      }
    }, [_c('div', {
      staticClass: "device-details-modal__app--name breakable"
    }, [_vm._v(_vm._s(package.appName))]), _vm._v(" "), _c('div', {
      staticClass: "device-details-modal__app--version"
    }, [_vm._v(_vm._s(package.versionName))])])
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "value": "gps"
    }
  }, [(_vm.device.Location) ? [(_vm.device.Location) ? _c('div', {
    staticClass: "modal__section device-details-modal__tab--item"
  }, [_c('h3', {
    staticClass: "title--general title--5"
  }, [_vm._v("Last seen")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("lastActivity")(_vm.device.LastConnected)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.device.Address))]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Lat: " + _vm._s(_vm.location.lat) + " Lon: " + _vm._s(_vm.location.long) + " ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal_section modal__section--flush modal__section--map",
    attrs: {
      "id": "map"
    }
  })] : [_c('div', {
    staticClass: "modal__section device-details-modal__tab--item"
  }, [_c('h3', {
    staticClass: "title--general title--5"
  }, [_vm._v("Last seen")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("lastActivity")(_vm.device.LastConnected)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.device.Address))]), _vm._v(" "), _c('p', [_vm._v("GPS location not available. Please allow location tracking in Webkey Client app.")])])]], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal__section"
  }, [_c('p', [_c('button', {
    staticClass: "link link--clean link--danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteDevice()
      }
    }
  }, [_vm._v("Remove device")])])])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d145e5e2","hasScoped":true}!./app/components/device-details-modal/template.html
// module id = 369
// module chunks = 0